import Collection from './collection'

class Partners extends Collection{
    fetch(){
        return this.axios.get('/partners')
    }
}

export default Partners;